<!-- Template mejorado -->
<div class="dialog-container">
  <h1 mat-dialog-title class="dialog-title">
    <mat-icon class="title-icon">person_add</mat-icon>
    Nueva Persona
  </h1>

  <mat-dialog-content *appRoles="['Personas.Crear']" class="dialog-content">
    <ngx-spinner
      [zIndex]="100"
      name="spPersona"
      bdColor="rgba(255,255,255,0.8)"
      size="default"
      color="var(--primary-color)"
      type="ball-atom"
      [fullScreen]="false">
    </ngx-spinner>

    <mat-card class="form-card">
      <mat-card-header class="section-header">
        <mat-card-title class="section-title">
          <mat-icon class="section-icon">info</mat-icon>
          Información Básica
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="personaForm">

          <!-- Sección Identificación -->
          <div class="form-section">
            <div class="section-subtitle">
              <mat-icon class="subtitle-icon">badge</mat-icon>
              <span>Identificación</span>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Tipo de Documento</mat-label>
                <mat-select formControlName="TiposDocumento"
                           (selectionChange)="selectTipoDocumento($event.value)">
                  <mat-option *ngFor="let tipoDoc of lstTipoDocumentoDto"
                             [value]="tipoDoc.id">
                    {{tipoDoc.descripcion}}
                  </mat-option>
                </mat-select>
                <mat-icon matPrefix>assignment_ind</mat-icon>
                <mat-error *ngIf="personaForm.controls['TiposDocumento'].hasError('required')">
                  Este campo es <strong>requerido</strong>
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Número de Documento</mat-label>
                <input matInput
                       type="text"
                       maxlength="50"
                       formControlName="NroDocumento"
                       placeholder="Ingrese el número">
                <mat-icon matPrefix>credit_card</mat-icon>
                <mat-error *ngIf="personaForm.controls['NroDocumento'].hasError('required')">
                  Este campo es <strong>requerido</strong>
                </mat-error>
                <mat-error *ngIf="personaForm.controls['NroDocumento'].hasError('maxlength')">
                  Supero el largo máximo
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <mat-divider class="section-divider"></mat-divider>

          <!-- Sección Datos Personales -->
          <div class="form-section">
            <div class="section-subtitle">
              <mat-icon class="subtitle-icon">person</mat-icon>
              <span>Datos Personales</span>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Nombre</mat-label>
                <input matInput
                       type="text"
                       maxlength="150"
                       style="text-transform: capitalize"
                       formControlName="Nombre"
                       placeholder="Ingrese el nombre">
                <mat-icon matPrefix>account_circle</mat-icon>
                <mat-error *ngIf="personaForm.controls['Nombre'].hasError('required')">
                  Este campo es <strong>requerido</strong>
                </mat-error>
                <mat-error *ngIf="personaForm.controls['Nombre'].hasError('maxlength')">
                  Supero el largo máximo
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Apellido</mat-label>
                <input matInput
                       type="text"
                       maxlength="150"
                       style="text-transform: capitalize"
                       formControlName="Apellido"
                       placeholder="Ingrese el apellido">
                <mat-icon matPrefix>account_circle</mat-icon>
                <mat-error *ngIf="personaForm.controls['Apellido'].hasError('maxlength')">
                  Supero el largo máximo
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <mat-divider class="section-divider"></mat-divider>

          <!-- Sección Contacto -->
          <div class="form-section">
            <div class="section-subtitle">
              <mat-icon class="subtitle-icon">contact_phone</mat-icon>
              <span>Información de Contacto</span>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Correo Electrónico</mat-label>
                <input matInput
                       type="email"
                       formControlName="Correo"
                       placeholder="ejemplo@correo.com">
                <mat-icon matPrefix>email</mat-icon>
                <mat-error *ngIf="personaForm.controls['Correo'].hasError('required')">
                  Este campo es <strong>requerido</strong>
                </mat-error>
                <mat-error *ngIf="personaForm.controls['Correo'].hasError('email')">
                  Formato de email inválido
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="form-field">
                <mat-label>Teléfono Personal</mat-label>
                <input matInput
                       type="tel"
                       maxlength="30"
                       formControlName="TelefonoPrincipal"
                       placeholder="Sin 0 y sin 15">
                <mat-icon matPrefix>phone</mat-icon>
                <mat-error *ngIf="personaForm.controls['TelefonoPrincipal'].hasError('required')">
                  Este campo es <strong>requerido</strong>
                </mat-error>
                <mat-error *ngIf="personaForm.controls['TelefonoPrincipal'].hasError('maxlength')">
                  Supero el largo máximo
                </mat-error>
              </mat-form-field>
            </div>
          </div>

        </form>
      </mat-card-content>
    </mat-card>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button
            mat-dialog-close
            class="cancel-button">
      <mat-icon>close</mat-icon>
      Cancelar
    </button>

    <button mat-raised-button
            color="primary"
            [disabled]="!personaForm.valid"
            *appRoles="['Personas.Crear']"
            (click)="onSubmit()"
            class="save-button">
      <mat-icon>save</mat-icon>
      Agregar Persona
    </button>
  </mat-dialog-actions>
</div>
